import { SettingsState } from "../reducer/state";
import { useAppState } from "../../../appState";

export default function useSettingsState(): SettingsState {
	return useAppState().settings;
}
